<template>
  <div>
    <div class="tile is-ancestor">
      <div class="tile is-vertical is-8">
        <div class="tile">
          <div class="tile is-parent is-vertical">
            <article class="tile is-child notification is-primary">
              <p class="title">Статистика</p>
              <p class="subtitle is-6">10/12/2018</p>
            </article>
            <article class="tile is-child notification is-warning">
              <p class="title">Аналитика</p>
              <p class="subtitle is-6">10/12/2018</p>
            </article>
          </div>
          <div class="tile is-parent">
            <article class="tile is-child notification is-info">
              <p class="title">Инфопанель</p>
              <p class="subtitle is-6">10/12/2018</p>
            </article>
          </div>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child notification is-grey">
            <p class="title">Отчеты</p>
            <p class="subtitle is-6">10/12/2018</p>
            <div class="content">
              <!-- Content -->
            </div>
          </article>
        </div>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child notification has-background-white">
          <div class="content">
            <p class="title is-4">
              <span class="icon is-small">
                <i class="mdi mdi-star-outline"></i>
              </span>
              Избранное ({{ favouriteGroups.length }})
            </p>

            <p class="subtitle is-6" v-if="favouriteGroups.length > 3">
              <router-link :to="{ name: 'favouritesList' }">Еще...</router-link>
            </p>

            <div class="content">
              <favourite-card
                v-for="(favouriteGroup, index) in favouriteGroups.slice(0, 3)"
                :key="index"
                :favouriteGroup="favouriteGroup"
                class="m-b-md"
              ></favourite-card>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {
    FavouriteCard: () =>
      import(/* webpackChunkName: "FavouriteCard" */ '@/components/user/favourites/FavouriteCard.vue')
  },
  computed: {
    ...mapGetters('favourites', {
      favouriteGroups: 'favouriteGroups'
    })
  }
};
</script>
